/** @clearscore/external-public.request-middleware v0.8.1: 2022-12-13 16:4 (assemble v5.5.2) **/
import { defer } from 'rxjs';
import deepmerge from 'deepmerge';
import addClientInstance from '@clearscore/external-public.add-client-instance';
import addUrlVariables from '@clearscore/helpers.add-url-variables';

/* eslint-disable camelcase */
function fromRequestAction(_ref, extendRequest) {
  var _ref$payload = _ref.payload,
    _ref$payload$request = _ref$payload.request,
    request = _ref$payload$request === void 0 ? {} : _ref$payload$request,
    meta = _ref$payload.meta;
  if (extendRequest) return defer(function () {
    return meta.client(deepmerge(request, extendRequest));
  });
  return defer(function () {
    return meta.client(request);
  });
}
/**
 * Check if action has correct structure in payload required for middleware
 * @param {object} action redux action
 * @returns {boolean} if action structure is correct
 */
function hasData(action) {
  var _action$payload, _action$payload$reque, _action$payload2, _action$payload2$requ, _action$payload3;
  return (action === null || action === void 0 ? void 0 : (_action$payload = action.payload) === null || _action$payload === void 0 ? void 0 : (_action$payload$reque = _action$payload.request) === null || _action$payload$reque === void 0 ? void 0 : _action$payload$reque.headers) && (action === null || action === void 0 ? void 0 : (_action$payload2 = action.payload) === null || _action$payload2 === void 0 ? void 0 : (_action$payload2$requ = _action$payload2.request) === null || _action$payload2$requ === void 0 ? void 0 : _action$payload2$requ.url) && (action === null || action === void 0 ? void 0 : (_action$payload3 = action.payload) === null || _action$payload3 === void 0 ? void 0 : _action$payload3.meta);
}
/**
 * Perform API request
 * @param {object} store redux store
 * @param {function} next next middleware func
 * @param {object} action redux action
 * @returns {void}
 */
function handleRequest(store, next, requestAction) {
  // dispatch original action type to reducer before attempting request
  next(requestAction);
  var _requestAction$payloa = requestAction.payload.request,
    request = _requestAction$payloa === void 0 ? {} : _requestAction$payloa;
  var dispatchSuccess = function dispatchSuccess(response, requestData) {
    return store.dispatch({
      type: "".concat(requestAction.type, "_SUCCESS"),
      payload: response.data,
      requestData: requestData.data,
      requestMeta: requestData.meta,
      statusCode: response.status
    });
  };
  var dispatchError = function dispatchError(_ref2, requestData) {
    var response = _ref2.response;
    return store.dispatch({
      type: "".concat(requestAction.type, "_ERROR"),
      payload: response,
      requestMeta: requestData.meta,
      statusCode: response === null || response === void 0 ? void 0 : response.status
    });
  };
  return fromRequestAction(requestAction).subscribe(function (response) {
    return dispatchSuccess(response, request);
  }, function (response) {
    return dispatchError(response, request);
  });
}

/**
 * If action has correct signature, perform API request.
 * Dispatch success or error actions
 * @param {object} store redux store
 * @returns {Function} middleware
 */
var internalOktaRequestMiddleware = function internalOktaRequestMiddleware(store) {
  return function (next) {
    return function (action) {
      var addVars = addUrlVariables(store);
      var addClients = addClientInstance(store, action);

      // add request data from helpers
      var requestAction = addVars(addClients);
      return hasData(requestAction) ? handleRequest(store, next, requestAction) : next(requestAction);
    };
  };
};
export { internalOktaRequestMiddleware as default };